// `web-<uuid>` → `web-<first uuid segment>` so same-repo (or default-repo)
// agent sessions stay distinguishable in the sidebar and context line without
// overflowing; non-web thread ids pass through unchanged (CSS-truncated by the
// caller). Shared by AgentView (context line) and AgentSessionList (rows).
export function shortThread(threadId: string): string {
  const match = threadId.match(/^web-([0-9a-f]{8})/i)
  return match ? `web-${match[1]}` : threadId
}
